import React from 'react';
import { Box, Typography, Paper, Stack } from '@mui/material';
import completedIcon from '../assets/icons/completed.gif'; // Replace with your icon path
import inProgressIcon from '../assets/icons/in-progress.gif'; // Replace with your icon path

const BuildDetails = () => {
  return (
    <Box p={2}>
      <Typography variant="h4" gutterBottom>
        Project Pipeline
      </Typography>
      <Paper elevation={3} sx={{ p: 2 }}>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-around">
          <Stack alignItems="center">
            <Typography>Build</Typography>
            <Box display="flex" alignItems="center">
              <img src={completedIcon} alt="Completed" width={90} height={75} style={{ marginRight: 8 }} />
              <Typography variant="button">build-job</Typography>
            </Box>
          </Stack>
          <Stack alignItems="center">
            <Typography>Scan</Typography>
            <Box display="flex" alignItems="center">
              <img src={completedIcon} alt="Completed" width={90} height={75} style={{ marginRight: 8 }} />
              <Typography variant="button">scan-job1</Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <img src={inProgressIcon} alt="In Progress" width={90} height={75} style={{ marginRight: 8 }} />
              <Typography variant="button">scan-job2</Typography>
            </Box>
          </Stack>
          <Stack alignItems="center">
            <Typography>Lint</Typography>
            <Box display="flex" alignItems="center">
              <img src={inProgressIcon} alt="In Progress" width={90} height={75} style={{ marginRight: 8 }} />
              <Typography variant="button">lint-job</Typography>
            </Box>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default BuildDetails;
